import { useMutation } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';

/**
 * 휴대폰 인증번호 발송 mutation — `POST /users/me/mobile/verify`(신규 번호). SMS Retriever 토큰은 웹 미지원이라
 * 생략(자동 채우기 제외). 응답에 만료시간(`expiresIn`)이 없어 타이머는 화면이 고정값(180s)으로 운용
 * [TODO:be-verify] BE 가 만료시간을 준다면 응답 반영. 후처리는 caller(SRP).
 */
export function useSendMobileCodeMutation() {
  const api = useApiAppLegacy();

  return useMutation<void, Error, string>({
    mutationFn: async (mobile) => {
      await api.user.verifyMobile({ profile: { mobile } });
    },
  });
}
